import { render, staticRenderFns } from "./app-primary.vue?vue&type=template&id=3a920388&scoped=true"
import script from "./app-primary.vue?vue&type=script&lang=js"
export * from "./app-primary.vue?vue&type=script&lang=js"
import style0 from "./app-primary.vue?vue&type=style&index=0&id=3a920388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a920388",
  null
  
)

export default component.exports